import Header from '@components/Header';
import colors from '@constants/colors';
import CloseLineIcon from '@icons/CloseLineIcon';
import { useFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

function ReceiptHeader() {
    const { t } = useTranslation('orderReceipt');
    const { pop } = useFlow();
    return (
        <Header title={t('header.title')}
            noShadow
            noBackIcon
            trailing={<CloseLineIcon size={24}
                color={colors.gray6}
                onClick={pop} />} />
    );
}

export default ReceiptHeader;
